import CarsDataTable from "../components/CarsDataTable";

function CarsPage() {
    return (
        <section>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                    <h1 className="h4 mb-1">Véhicules</h1>
                    <p className="text-secondary mb-0">Liste paginée des véhicules.</p>
                </div>
            </div>

            <CarsDataTable />
        </section>
    );
}

export default CarsPage;
